import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { useMemo } from 'react';
export function useDerivedSelectedItem(_ref) {
  var itemMap = _ref.itemMap,
      value = _ref.value,
      selectedItem = _ref.selectedItem,
      initialSelectedItem = _ref.initialSelectedItem,
      initialSelectedItems = _ref.initialSelectedItems,
      normaliser = _ref.normaliser,
      getItemId = _ref.getItemId;
  return {
    selectedItem: useMemo(function () {
      if (value === undefined && selectedItem === undefined || // We are just dealing with the individual selected item here
      // so we don't care about when either of these are arrays
      _Array$isArray(value) || _Array$isArray(selectedItem)) {
        // Undefined so we can remove this value from being passed
        // to downshift
        return undefined;
      }

      var normalisedItem = value ? normaliser(value) : selectedItem ? normaliser(selectedItem) : null;

      if (normalisedItem) {
        var _itemMap$get$normalis, _itemMap$get;

        // Make sure we get the original normalised item so that
        // downshift doesn't think that we're updating the controlled item
        return (_itemMap$get$normalis = (_itemMap$get = itemMap.get(getItemId(normalisedItem))) === null || _itemMap$get === void 0 ? void 0 : _itemMap$get.normalisedItem) !== null && _itemMap$get$normalis !== void 0 ? _itemMap$get$normalis : normalisedItem;
      }

      return normalisedItem;
    }, [value, selectedItem, itemMap, normaliser, getItemId]),
    selectedItems: useMemo(function () {
      if (value === null || selectedItem === null) {
        return [];
      }

      if (value && _Array$isArray(value)) {
        return _mapInstanceProperty(value).call(value, function (item) {
          var _itemMap$get$normalis2, _itemMap$get2;

          var normalisedItem = normaliser(item);
          return (_itemMap$get$normalis2 = (_itemMap$get2 = itemMap.get(getItemId(normalisedItem))) === null || _itemMap$get2 === void 0 ? void 0 : _itemMap$get2.normalisedItem) !== null && _itemMap$get$normalis2 !== void 0 ? _itemMap$get$normalis2 : normalisedItem;
        });
      }

      if (selectedItem && _Array$isArray(selectedItem)) {
        return _mapInstanceProperty(selectedItem).call(selectedItem, function (item) {
          var _itemMap$get$normalis3, _itemMap$get3;

          var normalisedItem = normaliser(item);
          return (_itemMap$get$normalis3 = (_itemMap$get3 = itemMap.get(getItemId(normalisedItem))) === null || _itemMap$get3 === void 0 ? void 0 : _itemMap$get3.normalisedItem) !== null && _itemMap$get$normalis3 !== void 0 ? _itemMap$get$normalis3 : normalisedItem;
        });
      } // Undefined so we can remove this value from being passed
      // to downshift


      return undefined;
    }, [value, selectedItem, itemMap, normaliser, getItemId]),
    initialSelectedItem: useMemo(function () {
      return initialSelectedItem ? normaliser(initialSelectedItem) : null;
    }, [initialSelectedItem, normaliser]),
    initialSelectedItems: useMemo(function () {
      var _context;

      return _mapInstanceProperty(_context = _Array$isArray(value) ? value : initialSelectedItems).call(_context, function (item) {
        return normaliser(item);
      });
    }, [value, initialSelectedItems, normaliser])
  };
}